import { render, staticRenderFns } from "./AccountNavigation.vue?vue&type=template&id=22fa2a66&"
import script from "./AccountNavigation.vue?vue&type=script&lang=js&"
export * from "./AccountNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports